/**
 * "Show no longer valid" (PRD-0075 R-C4): what an analyst marked as no longer holding or wrong is
 * hidden from the graph, the sidebar and the entity detail; switched on, it shows there greyed.
 * One switch for all of them.
 */
import { EyeOff } from 'lucide-react'
import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'
import { cn } from '@/utils/cn'
import { useShowNoLongerValid } from './useFactVisibility'

export function NoLongerValidToggle({ className }: { className?: string }) {
  const { t } = useTranslation()
  const [show, setShow] = useShowNoLongerValid()
  const id = useId()
  return (
    <div
      className={cn('flex items-center justify-between gap-2', className)}
      title={t('analystFacts.toggle.hint')}
    >
      <Label
        htmlFor={id}
        className="flex items-center gap-1.5 text-xs font-normal text-muted-foreground"
      >
        <EyeOff aria-hidden className="size-3.5" />
        {t('analystFacts.toggle.label')}
      </Label>
      <Switch id={id} size="sm" checked={show} onCheckedChange={setShow} />
    </div>
  )
}
